import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { touchLastSeen } from '@/lib/api/profiles';

export function useLastSeenWriter() {
  const profileId = useAuthStore((s) => s.profile?.id);

  useEffect(() => {
    if (!profileId) return;
    void touchLastSeen();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        void touchLastSeen();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [profileId]);
}
